import Utils from "../utils/Utils";

export const AUTO_DATA_UPDATE_RID = '0';
export const AUTHORIZATION_RID = '1';

export const GAME_TIMES_RID = Utils.getUniqNumber().toString();
export const LAST_RESULTS_RID = Utils.getUniqNumber().toString();
export const GET_SERVER_TIME_RID = Utils.getUniqNumber().toString();

const AUTHORIZATION_DATA = {
  command: "request_session",
  params: {
    site_id: "1",
    language: "en",
    aut_token: "E2300C86022F96246F4C6060DDF04A59"
  },
  rid: AUTHORIZATION_RID
}

const GAME_TIMES_DATA = {
  command: "get",
  params: {
    source: "betting",
    what: {
      sport: ["id", "name", "alias", "order"],
      game: ["@count", "start_ts", "text_info", "number", "round"],
      region: ["id"]
    },
    where: {
      game: {"@or": [{"type": 0}, {visible_in_prematch: true, type: 4}]},
      sport: {"id": {"@in": [8]}}
    },
    subscribe: true
  },
  rid: GAME_TIMES_RID
}

const LAST_RESULTS_DATA = {
  command: "get_last_results",
  params: {
    sport_id: 8,
    main_result_count: 5,
    details_result_count: 120
  },
  rid: LAST_RESULTS_RID
}

const GET_SERVER_TIME = {
  command: "get_server_time",
  params: {},
  rid: GET_SERVER_TIME_RID
}

export {
  AUTHORIZATION_DATA, GAME_TIMES_DATA, LAST_RESULTS_DATA, GET_SERVER_TIME
};